import _asyncToGenerator from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { AbstractSqliteDriver } from "../sqlite-abstract/AbstractSqliteDriver";
import { SqljsQueryRunner } from "./SqljsQueryRunner";
import { DriverPackageNotInstalledError } from "../../error/DriverPackageNotInstalledError";
import { DriverOptionNotSetError } from "../../error/DriverOptionNotSetError";
import { PlatformTools } from "../../platform/PlatformTools";
import { OrmUtils } from "../../util/OrmUtils";
import { TypeORMError } from "../../error";
export var SqljsDriver = /*#__PURE__*/function (_AbstractSqliteDriver) {
  _inherits(SqljsDriver, _AbstractSqliteDriver);
  var _super = _createSuper(SqljsDriver);
  // -------------------------------------------------------------------------
  // Constructor
  // -------------------------------------------------------------------------
  function SqljsDriver(connection) {
    var _this;
    _classCallCheck(this, SqljsDriver);
    _this = _super.call(this, connection);
    // If autoSave is enabled by user, location or autoSaveCallback have to be set
    // because either autoSave saves to location or calls autoSaveCallback.
    if (_this.options.autoSave && !_this.options.location && !_this.options.autoSaveCallback) {
      throw new DriverOptionNotSetError("location or autoSaveCallback");
    }
    // load sql.js package
    _this.loadDependencies();
    return _this;
  }
  // -------------------------------------------------------------------------
  // Public Methods
  // -------------------------------------------------------------------------
  /**
   * Performs connection to the database.
   */
  _createClass(SqljsDriver, [{
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.createDatabaseConnection();
            case 2:
              this.databaseConnection = _context.sent;
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function connect() {
        return _connect.apply(this, arguments);
      }
      return connect;
    }()
    /**
     * Closes connection with database.
     */
  }, {
    key: "disconnect",
    value: function () {
      var _disconnect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.queryRunner = undefined;
              this.databaseConnection.close();
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function disconnect() {
        return _disconnect.apply(this, arguments);
      }
      return disconnect;
    }()
    /**
     * Creates a query runner used to execute database queries.
     */
  }, {
    key: "createQueryRunner",
    value: function createQueryRunner(mode) {
      if (!this.queryRunner) this.queryRunner = new SqljsQueryRunner(this);
      return this.queryRunner;
    }
    /**
     * Loads a database from a given file (Node.js), local storage key (browser) or array.
     * This will delete the current database!
     */
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(fileNameOrLocalStorageOrData) {
        var checkIfFileOrLocalStorageExists,
          database,
          localStorageContent,
          _args3 = arguments;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              checkIfFileOrLocalStorageExists = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : true;
              if (!(typeof fileNameOrLocalStorageOrData === "string")) {
                _context3.next = 38;
                break;
              }
              if (!(PlatformTools.type === "node")) {
                _context3.next = 15;
                break;
              }
              if (!PlatformTools.fileExist(fileNameOrLocalStorageOrData)) {
                _context3.next = 8;
                break;
              }
              database = PlatformTools.readFileSync(fileNameOrLocalStorageOrData);
              return _context3.abrupt("return", this.createDatabaseConnectionWithImport(database));
            case 8:
              if (!checkIfFileOrLocalStorageExists) {
                _context3.next = 12;
                break;
              }
              throw new TypeORMError("File ".concat(fileNameOrLocalStorageOrData, " does not exist"));
            case 12:
              return _context3.abrupt("return", this.createDatabaseConnectionWithImport());
            case 13:
              _context3.next = 36;
              break;
            case 15:
              // browser
              // fileNameOrLocalStorageOrData should be a local storage / indexedDB key
              localStorageContent = null;
              if (!this.options.useLocalForage) {
                _context3.next = 26;
                break;
              }
              if (!window.localforage) {
                _context3.next = 23;
                break;
              }
              _context3.next = 20;
              return window.localforage.getItem(fileNameOrLocalStorageOrData);
            case 20:
              localStorageContent = _context3.sent;
              _context3.next = 24;
              break;
            case 23:
              throw new TypeORMError("localforage is not defined - please import localforage.js into your site");
            case 24:
              _context3.next = 27;
              break;
            case 26:
              localStorageContent = PlatformTools.getGlobalVariable().localStorage.getItem(fileNameOrLocalStorageOrData);
            case 27:
              if (!(localStorageContent != null)) {
                _context3.next = 31;
                break;
              }
              return _context3.abrupt("return", this.createDatabaseConnectionWithImport(JSON.parse(localStorageContent)));
            case 31:
              if (!checkIfFileOrLocalStorageExists) {
                _context3.next = 35;
                break;
              }
              throw new TypeORMError("File ".concat(fileNameOrLocalStorageOrData, " does not exist"));
            case 35:
              return _context3.abrupt("return", this.createDatabaseConnectionWithImport());
            case 36:
              _context3.next = 39;
              break;
            case 38:
              return _context3.abrupt("return", this.createDatabaseConnectionWithImport(fileNameOrLocalStorageOrData));
            case 39:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function load(_x) {
        return _load.apply(this, arguments);
      }
      return load;
    }()
    /**
     * Saved the current database to the given file (Node.js), local storage key (browser) or
     * indexedDB key (browser with enabled useLocalForage option).
     * If no location path is given, the location path in the options (if specified) will be used.
     */
  }, {
    key: "save",
    value: function () {
      var _save = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(location) {
        var path, content, database, databaseArray;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(!location && !this.options.location)) {
                _context4.next = 2;
                break;
              }
              throw new TypeORMError("No location is set, specify a location parameter or add the location option to your configuration");
            case 2:
              path = "";
              if (location) {
                path = location;
              } else if (this.options.location) {
                path = this.options.location;
              }
              if (!(PlatformTools.type === "node")) {
                _context4.next = 16;
                break;
              }
              _context4.prev = 5;
              content = Buffer.from(this.databaseConnection.export());
              _context4.next = 9;
              return PlatformTools.writeFile(path, content);
            case 9:
              _context4.next = 14;
              break;
            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](5);
              throw new TypeORMError("Could not save database, error: ".concat(_context4.t0));
            case 14:
              _context4.next = 28;
              break;
            case 16:
              database = this.databaseConnection.export(); // convert Uint8Array to number array to improve local-storage storage
              databaseArray = [].slice.call(database);
              if (!this.options.useLocalForage) {
                _context4.next = 27;
                break;
              }
              if (!window.localforage) {
                _context4.next = 24;
                break;
              }
              _context4.next = 22;
              return window.localforage.setItem(path, JSON.stringify(databaseArray));
            case 22:
              _context4.next = 25;
              break;
            case 24:
              throw new TypeORMError("localforage is not defined - please import localforage.js into your site");
            case 25:
              _context4.next = 28;
              break;
            case 27:
              PlatformTools.getGlobalVariable().localStorage.setItem(path, JSON.stringify(databaseArray));
            case 28:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[5, 11]]);
      }));
      function save(_x2) {
        return _save.apply(this, arguments);
      }
      return save;
    }()
    /**
     * This gets called by the QueryRunner when a change to the database is made.
     * If a custom autoSaveCallback is specified, it get's called with the database as Uint8Array,
     * otherwise the save method is called which saves it to file (Node.js), local storage (browser)
     * or indexedDB (browser with enabled useLocalForage option).
     * Don't auto-save when in transaction as the call to export will end the current transaction
     */
  }, {
    key: "autoSave",
    value: function () {
      var _autoSave = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _a;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!(this.options.autoSave && !((_a = this.queryRunner) === null || _a === void 0 ? void 0 : _a.isTransactionActive))) {
                _context5.next = 8;
                break;
              }
              if (!this.options.autoSaveCallback) {
                _context5.next = 6;
                break;
              }
              _context5.next = 4;
              return this.options.autoSaveCallback(this.export());
            case 4:
              _context5.next = 8;
              break;
            case 6:
              _context5.next = 8;
              return this.save();
            case 8:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function autoSave() {
        return _autoSave.apply(this, arguments);
      }
      return autoSave;
    }()
    /**
     * Returns the current database as Uint8Array.
     */
  }, {
    key: "export",
    value: function _export() {
      return this.databaseConnection.export();
    }
    /**
     * Creates generated map of values generated or returned by database after INSERT query.
     */
  }, {
    key: "createGeneratedMap",
    value: function createGeneratedMap(metadata, insertResult) {
      var _this2 = this;
      var generatedMap = metadata.generatedColumns.reduce(function (map, generatedColumn) {
        // seems to be the only way to get the inserted id, see https://github.com/kripken/sql.js/issues/77
        if (generatedColumn.isPrimary && generatedColumn.generationStrategy === "increment") {
          var query = "SELECT last_insert_rowid()";
          try {
            var result = _this2.databaseConnection.exec(query);
            _this2.connection.logger.logQuery(query);
            return OrmUtils.mergeDeep(map, generatedColumn.createValueMap(result[0].values[0][0]));
          } catch (e) {
            _this2.connection.logger.logQueryError(e, query, []);
          }
        }
        return map;
      }, {});
      return Object.keys(generatedMap).length > 0 ? generatedMap : undefined;
    }
    // -------------------------------------------------------------------------
    // Protected Methods
    // -------------------------------------------------------------------------
    /**
     * Creates connection with the database.
     * If the location option is set, the database is loaded first.
     */
  }, {
    key: "createDatabaseConnection",
    value: function createDatabaseConnection() {
      if (this.options.location) {
        return this.load(this.options.location, false);
      }
      return this.createDatabaseConnectionWithImport(this.options.database);
    }
    /**
     * Creates connection with an optional database.
     * If database is specified it is loaded, otherwise a new empty database is created.
     */
  }, {
    key: "createDatabaseConnectionWithImport",
    value: function () {
      var _createDatabaseConnectionWithImport = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(database) {
        var isLegacyVersion, sqlite;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              // sql.js < 1.0 exposes an object with a `Database` method.
              isLegacyVersion = typeof this.sqlite.Database === "function";
              if (!isLegacyVersion) {
                _context6.next = 5;
                break;
              }
              _context6.t0 = this.sqlite;
              _context6.next = 8;
              break;
            case 5:
              _context6.next = 7;
              return this.sqlite(this.options.sqlJsConfig);
            case 7:
              _context6.t0 = _context6.sent;
            case 8:
              sqlite = _context6.t0;
              if (database && database.length > 0) {
                this.databaseConnection = new sqlite.Database(database);
              } else {
                this.databaseConnection = new sqlite.Database();
              }
              this.databaseConnection.exec("PRAGMA foreign_keys = ON");
              return _context6.abrupt("return", this.databaseConnection);
            case 12:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function createDatabaseConnectionWithImport(_x3) {
        return _createDatabaseConnectionWithImport.apply(this, arguments);
      }
      return createDatabaseConnectionWithImport;
    }()
    /**
     * If driver dependency is not given explicitly, then try to load it via "require".
     */
  }, {
    key: "loadDependencies",
    value: function loadDependencies() {
      if (PlatformTools.type === "browser") {
        var sqlite = this.options.driver || window.SQL;
        this.sqlite = sqlite;
      } else {
        try {
          var _sqlite = this.options.driver || PlatformTools.load("sql.js");
          this.sqlite = _sqlite;
        } catch (e) {
          throw new DriverPackageNotInstalledError("sql.js", "sql.js");
        }
      }
    }
  }]);
  return SqljsDriver;
}(AbstractSqliteDriver);